import { MapConfigurationModel } from '@geosecma/settings';
import { types } from 'mobx-state-tree';
import { RowModel } from 'models/rowModel';

const MapConfigurationAttributes = types.model('MapConfigurationAttributes', {
  typeName: types.maybe(types.string),
  rowVersion: types.maybe(types.string),
  content: '{}'
});

export const MapConfigurationStore = types
  .compose(RowModel, MapConfigurationAttributes, MapConfigurationModel)
  .named('MapConfigurationStore');
